import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import PageNotFound from '../../assets/images/404-pagenot-found.png'
import { home } from '../../Routes/routingConsts'

const Error404 = () => {
    const navigate = useNavigate()
    return (
        <>
            <div className="page-not-found topspace">
                <div className="container">
                    <div className="error-404">
                        {/* <div className="error-image">
                            <img src={PageNotFound} alt="" />
                        </div> */}
                        <div className="error-content">
                            <h1>404</h1>
                            <p>Page Not Found</p>
                            <Button className="common-btn pagenot-found-btn" onClick={()=>navigate(home)}>Go To Homepage</Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Error404
